import { MS as c, WEBKIT as r, MOZ as f } from "./index.es255.js";
import { hash as m, replace as a, charat as n, strlen as w, indexof as o, match as u, substr as d } from "./index.es345.js";
function k(s, e, t) {
  switch (m(s, e)) {
    // color-adjust
    case 5103:
      return r + "print-" + s + s;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return r + s + s;
    // tab-size
    case 4789:
      return f + s + s;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return r + s + f + s + c + s + s;
    // writing-mode
    case 5936:
      switch (n(s, e + 11)) {
        // vertical-l(r)
        case 114:
          return r + s + c + a(s, /[svh]\w+-[tblr]{2}/, "tb") + s;
        // vertical-r(l)
        case 108:
          return r + s + c + a(s, /[svh]\w+-[tblr]{2}/, "tb-rl") + s;
        // horizontal(-)tb
        case 45:
          return r + s + c + a(s, /[svh]\w+-[tblr]{2}/, "lr") + s;
      }
    // flex, flex-direction, scroll-snap-type, writing-mode
    case 6828:
    case 4268:
    case 2903:
      return r + s + c + s + s;
    // order
    case 6165:
      return r + s + c + "flex-" + s + s;
    // align-items
    case 5187:
      return r + s + a(s, /(\w+).+(:[^]+)/, r + "box-$1$2" + c + "flex-$1$2") + s;
    // align-self
    case 5443:
      return r + s + c + "flex-item-" + a(s, /flex-|-self/g, "") + (u(s, /flex-|baseline/) ? "" : c + "grid-row-" + a(s, /flex-|-self/g, "")) + s;
    // align-content
    case 4675:
      return r + s + c + "flex-line-pack" + a(s, /align-content|flex-|-self/g, "") + s;
    // flex-shrink
    case 5548:
      return r + s + c + a(s, "shrink", "negative") + s;
    // flex-basis
    case 5292:
      return r + s + c + a(s, "basis", "preferred-size") + s;
    // flex-grow
    case 6060:
      return r + "box-" + a(s, "-grow", "") + r + s + c + a(s, "grow", "positive") + s;
    // transition
    case 4554:
      return r + a(s, /([^-])(transform)/g, "$1" + r + "$2") + s;
    // cursor
    case 6187:
      return a(a(a(s, /(zoom-|grab)/, r + "$1"), /(image-set)/, r + "$1"), s, "") + s;
    // background, background-image
    case 5495:
    case 3959:
      return a(s, /(image-set\([^]*)/, r + "$1$`$1");
    // justify-content
    case 4968:
      return a(a(s, /(.+:)(flex-)?(.*)/, r + "box-pack:$3" + c + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + r + s + s;
    // justify-self
    case 4200:
      if (!u(s, /flex-|baseline/)) return c + "grid-column-align" + d(s, e) + s;
      break;
    // grid-template-(columns|rows)
    case 2592:
    case 3360:
      return c + a(s, "template-", "") + s;
    // grid-(row|column)-start
    case 4384:
    case 3616:
      return t && t.some(function(i, l) {
        return e = l, u(i.props, /grid-\w+-end/);
      }) ? ~o(s + (t = t[e].value), "span", 0) ? s : c + a(s, "-start", "") + s + c + "grid-row-span:" + (~o(t, "span", 0) ? u(t, /\d+/) : +u(t, /\d+/) - +u(s, /\d+/)) + ";" : c + a(s, "-start", "") + s;
    // grid-(row|column)-end
    case 4896:
    case 4128:
      return t && t.some(function(i) {
        return u(i.props, /grid-\w+-start/);
      }) ? s : c + a(a(s, "-end", "-span"), "span ", "") + s;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return a(s, /(.+)-inline(.+)/, r + "$1$2") + s;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (w(s) - 1 - e > 6)
        switch (n(s, e + 1)) {
          // (m)ax-content, (m)in-content
          case 109:
            if (n(s, e + 4) !== 45)
              break;
          // (f)ill-available, (f)it-content
          case 102:
            return a(s, /(.+:)(.+)-([^]+)/, "$1" + r + "$2-$3$1" + f + (n(s, e + 3) == 108 ? "$3" : "$2-$3")) + s;
          // (s)tretch
          case 115:
            return ~o(s, "stretch", 0) ? k(a(s, "stretch", "fill-available"), e, t) + s : s;
        }
      break;
    // grid-(column|row)
    case 5152:
    case 5920:
      return a(s, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(i, l, p, g, h, b, x) {
        return c + l + ":" + p + x + (g ? c + l + "-span:" + (h ? b : +b - +p) + x : "") + s;
      });
    // position: sticky
    case 4949:
      if (n(s, e + 6) === 121)
        return a(s, ":", ":" + r) + s;
      break;
    // display: (flex|inline-flex|grid|inline-grid)
    case 6444:
      switch (n(s, n(s, 14) === 45 ? 18 : 11)) {
        // (inline-)?fle(x)
        case 120:
          return a(s, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + r + (n(s, 14) === 45 ? "inline-" : "") + "box$3$1" + r + "$2$3$1" + c + "$2box$3") + s;
        // (inline-)?gri(d)
        case 100:
          return a(s, ":", ":" + c) + s;
      }
      break;
    // scroll-margin, scroll-margin-(top|right|bottom|left)
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return a(s, "scroll-", "scroll-snap-") + s;
  }
  return s;
}
export {
  k as prefix
};
//# sourceMappingURL=index.es347.js.map
